import { SpcResultsPos, SpcTogglesMap } from '../../types/spc.js';
import { SPC_ENABLED_DEFAULT } from '../../utils/spcConstants.js';


export interface IssuesCount {
    enabledIssues: number;
    allIssues: number;
}


export function countSpcIssues(
    spcChecksFull: Pick<SpcResultsPos<any>, 'position' | 'aggregated'>[],
    spcTogglesMap: SpcTogglesMap,
): IssuesCount {
    let enabledIssues = 0;
    let allIssues = 0;
    for (const { position, aggregated } of spcChecksFull) {
        const enabledChecks = spcTogglesMap[position.positionNumber] ?? SPC_ENABLED_DEFAULT;
        for (const [checkIndex, isEnabled] of enabledChecks.entries()) {
            const isIssue = aggregated[checkIndex];
            if (isIssue) allIssues++;
            if (isEnabled && isIssue) enabledIssues++;
        }
    }

    return {
        enabledIssues,
        allIssues,
    }
}
